class RichRelevanceErrorInstrumentationController {
    constructor($window, richRelevanceService) {
        richRelevanceService.getInformation()
            .then(() => {
                $window.R3_ERROR = new $window.r3_error(); // eslint-disable-line new-cap
                $window.rr_flush_onload();

                $window.r3();
            });
    }
}

const richRelevanceErrorInstrumentationComponentDefinition = {
    controller: ['$window', 'RichRelevanceService', RichRelevanceErrorInstrumentationController],
};

module.exports = {
    RichRelevanceErrorInstrumentationController,
    richRelevanceErrorInstrumentationComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/richrelevance/instrumentation/rr-error-instrumentation.component.js